import { memo } from "react";

import { tw, type TTailwindString } from "classnames";

type Props = {
  isActive: boolean;
};

const styles = {
  base: (isActive: boolean) =>
    tw(
      "relative",
      "box-border",
      "w-full",
      "cursor-pointer",
      "overflow-hidden",
      "rounded",
      "border-solid",
      "border-placeholder",
      "bg-placeholder",
      "px-4",
      "py-6",
      {
        [tw(
          "border-3",
          "h-[175px]" as TTailwindString,
          "md:h-[180px]" as TTailwindString
        )]: isActive,
        [tw(
          "border-2",
          "h-[108px]" as TTailwindString,
          "md:h-[97.5px]" as TTailwindString
        )]: !isActive,
      }
    ),
  badge: tw(
    "absolute",
    "right-0",
    "top-0",
    "flex",
    "h-4",
    "w-[90px]" as TTailwindString,
    "rounded",
    "rounded-t-none",
    "rounded-br-none",
    "bg-placeholder",
    "px-2",
    "py-0.5",
    "md:h-4",
    "md:px-2"
  ),
  heading: tw(
    "mb-2.5",
    "flex",
    "w-full",
    "items-baseline",
    "justify-between",
    "gap-x-4",
    "md:mb-3",
    "md:mt-1"
  ),
  headingLine1: tw(
    "h-5",
    "w-full",
    "max-w-[100px]" as TTailwindString,
    "rounded-full",
    "bg-placeholder",
    "md:max-w-[120px]" as TTailwindString
  ),
  headingLine2: tw(
    "h-3",
    "w-full",
    "max-w-[100px]" as TTailwindString,
    "rounded-full",
    "bg-placeholder"
  ),
  subheading: tw("mb-6", "flex", "w-full", "flex-col", "gap-2"),
  subheadingLine1: (isActive: boolean) =>
    tw(
      "h-2",
      "w-full",
      "max-w-[200px]" as TTailwindString,
      "rounded-full",
      "bg-placeholder",
      {
        ["md:max-w-[300px]" as TTailwindString]: isActive,
      }
    ),
  subheadingLine2: tw(
    "h-2",
    "w-full",
    "max-w-[60px]" as TTailwindString,
    "rounded-full",
    "bg-placeholder",
    "md:hidden"
  ),
  title: tw("mb-3.5", "flex", "w-full", "items-center", "gap-x-1", "md:mb-3"),
  titleLine1: tw(
    "h-4",
    "w-full",
    "max-w-[46px]" as TTailwindString,
    "rounded-full",
    "bg-placeholder"
  ),
  titleLine2: tw(
    "h-3",
    "w-full",
    "max-w-[80px]" as TTailwindString,
    "rounded-full",
    "bg-placeholder"
  ),
  productOptionContainer: tw(
    "flex",
    "w-full",
    "items-center",
    "gap-[10px]" as TTailwindString
  ),
  productOptionOuter: tw(
    "h-[30px]" as TTailwindString,
    "w-[30px]" as TTailwindString,
    "rounded-full",
    "border-solid",
    "border-transparent",
    "first:border-placeholder" as TTailwindString
  ),
  productOption: tw(
    "m-0",
    "box-border",
    "flex",
    "h-full",
    "w-full",
    "items-center",
    "justify-center",
    "rounded-full",
    "border-3",
    "border-solid",
    "border-transparent",
    "bg-placeholder",
    "bg-clip-padding",
    "p-0"
  ),
};

const ProductComboOptionPlaceholderBase = ({ isActive }: Props) => (
  <div className={styles.base(isActive)} data-placeholder-region="component">
    <>
      {/* Product Option Badge */}
      {!isActive && <div className={styles.badge}></div>}

      {/* Product Option Heading */}
      <div className={styles.heading}>
        <div className={styles.headingLine1}></div>
        <div className={styles.headingLine2}></div>
      </div>

      {/* Product Option Subheading */}
      <div className={styles.subheading}>
        <div className={styles.subheadingLine1(isActive)}></div>
        {!isActive && <div className={styles.subheadingLine2}></div>}
      </div>

      {/* Product Option Title */}
      {isActive && (
        <div className={styles.title}>
          <div className={styles.titleLine1}></div>
          <div className={styles.titleLine2}></div>
        </div>
      )}

      {/* Product Options */}
      {isActive && (
        <div className={styles.productOptionContainer}>
          {Array.from({ length: 5 }).map((_, index) => (
            <div className={styles.productOptionOuter} key={index}>
              <div className={styles.productOption}></div>
            </div>
          ))}
        </div>
      )}
    </>
  </div>
);
export const ProductComboOptionPlaceholder = memo(
  ProductComboOptionPlaceholderBase
);
